import { vehicles } from "../data/vehicles";

function VehicleCard({ vehicle }) {
  const title = vehicle.year
    ? `${vehicle.year} - ${vehicle.brand} - ${vehicle.type}`
    : `${vehicle.brand} - ${vehicle.type}`;
  const imageUrl = `/vehicle-images/${vehicle.folder}/1.jpg`;

  return (
    <div className="vehicle-card">
      <div
        className="vehicle-image"
        style={{ backgroundImage: `url(${imageUrl})` }}
      />
      <div className="vehicle-info">
        <h3>{title}</h3>
        <div className="protection-level">Protection Level: {vehicle.armor}</div>
        <p><strong>Price: US$ {vehicle.price.toLocaleString()}</strong></p>
        <ul className="vehicle-features">
          {vehicle.specs.map((spec, i) => (
            <li key={i}>{spec}</li>
          ))}
        </ul>
        <p className="vehicle-cta">Contact us to find similar vehicles - we update examples monthly</p>
      </div>
    </div>
  );
}

function VehicleShowcase({ selectedMakes, selectedModels }) {
  const filteredVehicles = vehicles.filter((v) => {
    const makeMatch = selectedMakes.length === 0 || selectedMakes.includes(v.brand);
    const modelMatch = selectedModels.length === 0 || selectedModels.includes(v.type);
    return makeMatch && modelMatch;
  });

  return (
    <section className="section vehicles-showcase" id="vehicles">
      <div className="container">
        <h2 className="section-title">Examples of Vehicles - June 2026</h2>
        <p className="section-subtitle">
          Each month we showcase examples of armored vehicles we can source. These represent the types and quality of vehicles available through our network in Colombia. Contact us to find similar vehicles or discuss your specific requirements.
        </p>

        <div className="vehicle-grid">
          {filteredVehicles.map((vehicle) => (
            <VehicleCard key={vehicle.folder} vehicle={vehicle} />
          ))}
        </div>

        {filteredVehicles.length === 0 && (
          <p className="no-results">No vehicles match your selection. Try different makes or models.</p>
        )}

        <div className="showcase-note">
          <h3>Monthly Vehicle Showcase</h3>
          <p>We update our vehicle examples every month to show the current types and quality available. Each showcase represents real vehicles from our network that we can source for international clients.</p>
        </div>
      </div>
    </section>
  );
}

export default VehicleShowcase;
